import React from "react";
import { useNavigate } from "react-router-dom";
import { MessageCircle } from "lucide-react";

// Floating quote button, fixed bottom-right (mimics the original site).
const FloatingDevis = () => {
  const navigate = useNavigate();
  return (
    <button
      onClick={() => navigate("/contact")}
      aria-label="Devis"
      className="fixed bottom-6 right-6 z-50 bg-[#C9A227] hover:bg-[#b8931f] text-white rounded-full p-4 shadow-lg hover:shadow-xl transition-all duration-300 flex items-center gap-2 group"
    >
      <MessageCircle className="w-6 h-6" />
      <span className="hidden sm:inline-block font-semibold group-hover:scale-105 transition-transform">
        Devis gratuit
      </span>
    </button>
  );
};

export default FloatingDevis;
